import LoadingButton from '@mui/lab/LoadingButton';
import {Button, Stack, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {INGESTION_STATUSES} from '../../../constants';
import {
  DARK_TEXT_COLOR,
  GREEN_BUTTON,
  GREEN_BUTTON_DARK,
  GREY_BORDER_LIGHTER,
  TEAL_PRIMARY,
  TEAL_PRIMARY_DARK,
  TEAL_PRIMARY_DISABLED,
  WHITE_100,
} from '../../../theme';
import Loading from '../../Loading';

const styles = {
  closeWindowButton: {
    border: `1px solid ${GREY_BORDER_LIGHTER}`,
    borderRadius: '0.5rem',
    height: '2.25rem',
    paddingHorizontal: '1rem',
    paddingVertical: '0.375rem',
  },
  closeWindowButtonLabel: {
    color: DARK_TEXT_COLOR,
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '160%',
  },
  contactSupportButton: {
    '&:hover': {
      backgroundColor: GREEN_BUTTON_DARK,
      textDecoration: 'none',
    },
    alignItems: 'center',
    backgroundColor: GREEN_BUTTON,
    borderRadius: '0.5rem',
    display: 'flex',
    height: '2.25rem',
    justifyContent: 'center',
    paddingHorizontal: '1rem',
    paddingVertical: '0.375rem',
    textDecoration: 'none',
    width: '9.3125rem',
  },
  contactSupportButtonLabel: {
    color: WHITE_100,
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '160%',
  },
  createButton: {
    '&:disabled': {
      backgroundColor: TEAL_PRIMARY_DISABLED,
    },
    '&:hover': {
      backgroundColor: TEAL_PRIMARY_DARK,
    },
    background: TEAL_PRIMARY,
    borderRadius: '0.5rem',
    color: WHITE_100,
    height: '2.25rem',
    paddingLeft: '0.75rem',
    paddingRight: '1rem',
    paddingVertical: '0.625rem',
  },
  createButtonLabel: {
    color: WHITE_100,
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '140%',
  },
};

export const CTAButton = (props) => {
  const {
    disabled,
    documentId,
    ingestionStatus,
    isPdfReviewAssistantFlow,
    isIngestionComplete,
    isProcessing,
    loading,
    onClose,
    onCreate,
  } = props;

  const navigate = useNavigate();
  if (isProcessing && !isIngestionComplete && !isPdfReviewAssistantFlow) {
    return (
      <Stack direction="row" spacing="0.625rem">
        <Button
          onClick={onClose}
          sx={{...styles.closeWindowButton, width: '9.3125rem'}}
        >
          <Typography style={styles.closeWindowButtonLabel}>
            Close window
          </Typography>
        </Button>
        {ingestionStatus === INGESTION_STATUSES.failed && (
          <Button
            component="a"
            href="mailto:support@inscopehq.com"
            onClick={onClose}
            sx={styles.contactSupportButton}
          >
            <Typography style={styles.contactSupportButtonLabel}>
              Contact Support
            </Typography>
          </Button>
        )}
      </Stack>
    );
  }

  if (!isProcessing && isIngestionComplete && !isPdfReviewAssistantFlow) {
    return (
      <Button
        disabled={disabled}
        onClick={() => navigate(`/documents/${documentId}`)}
        sx={styles.createButton}
        variant="contained"
      >
        <Typography style={styles.createButtonLabel}>Open</Typography>
      </Button>
    );
  }

  return (
    <LoadingButton
      type="submit"
      disabled={disabled}
      loading={loading}
      loadingIndicator={
        <Loading loading={loading} loadingProps={{color: WHITE_100}} />
      }
      onClick={onCreate}
      sx={styles.createButton}
      variant="contained"
    >
      {!loading && (
        <Typography style={styles.createButtonLabel}>
          {isPdfReviewAssistantFlow ? 'Upload' : 'Create new report'}
        </Typography>
      )}
    </LoadingButton>
  );
};

CTAButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  documentId: PropTypes.string.isRequired,
  ingestionStatus: PropTypes.string.isRequired,
  isIngestionComplete: PropTypes.bool.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  isPdfReviewAssistantFlow: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
};
